const boxbuttons = document.querySelectorAll(".js-box-link");

boxbuttons.forEach((boxbutton) => {
  const boxid = boxbutton.dataset.box;
  const boxstring = `[data-boxo="` + boxid + `"]`;
  const boxpopup = document.querySelector(boxstring);
  document.addEventListener("click", function (event) {
    // If user clicks inside the element, do nothing
    if (event.target == boxbutton || event.target == boxpopup) return;
    // If user clicks outside the element, hide it!
    boxpopup.style.display = "none";
  });
  boxbutton.onclick = function () {
    boxpopup.style.display = "block";
  };
});